import { LegacyProfileLink, ProfileLink } from '@/payload-types'
import RenderRichTexComponent from '../rich-text-render/richTextRender'
import ReadMoreSnippetComponent from './read-more-snippet'
import Image from 'next/image'
import RenderPublicDetails from '../public-profile-card/profileDetails'
import { createProfileDetails } from '@/lib/profileFunction'
import SnippetComponent from './snippet'
import Link from 'next/link'
interface IProps {
  profileLink?: ProfileLink | LegacyProfileLink
}

export function IndividualSnippetComponent({ profileLink }: IProps) {
  if (
    profileLink?.blockType === 'profilelink' &&
    typeof profileLink.profileLink === 'object' &&
    typeof profileLink.profileLink?.profileEntity === 'object'
  ) {
    const profession =
      profileLink.profileLink?.profileEntity.status === 'Professor' ? 'professor' : 'individual'
    const arrayOfDetails = createProfileDetails(profileLink.profileLink)
    return (
      <SnippetComponent text={profileLink?.textToDisplay}>
        <span className="block relative text-sm bg-black min-h-9 w-64 p-2 text-white rounded-t-lg right-[1px]">
          <span className="block font-semibold	">
            {profileLink.profileLink?.profileEntity.fullName}
          </span>
        </span>
        <span className="block px-3 py-2">
          <span className="flex flex-row">
            <span className="w-[87px] h-[87px] rounded-full border ">
              <Image
                className={`h-full w-full rounded-full object-cover`}
                src={`${
                  process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
                }${
                  typeof profileLink.profileLink?.profileImage === 'object'
                    ? profileLink.profileLink?.profileImage?.sizes?.thumbnail?.url
                    : ''
                }`}
                width={600}
                height={600}
                alt={''}
              />
            </span>
            <span className="ml-[10px] individualDetails w-[144px] h-[85px] leading-[18px]">
              <RenderPublicDetails arrayOfData={arrayOfDetails} showMore={false} allItems={false} />
            </span>
          </span>

          <span className="font-normal text-sm !m-0">
            <span className="!line-clamp-[10] richTextContentAccordion">
              <RenderRichTexComponent
                richTextField={profileLink.profileLink?.overview}
                textOnly={true}
              />
            </span>
            <Link
              href={`/${profession}/${profileLink.profileLink?.slug}`}
              className="font-bold text-sm !text-black flex flex-row items-center outline-0"
              target="_blank"
              prefetch={false}
            >
              <ReadMoreSnippetComponent />
            </Link>
          </span>
        </span>
      </SnippetComponent>
    )
  } else {
    return <></>
  }
}
